<template>
    <div class="contact-filters-toolbar">
        <CommonFilterTool
            v-model="breakdownFilter"
            :keep-state-on-query-params="false"
            :filter-meta="filterMetas"
            :label-formatter="filterLabelFormatter"
            @addFilter="addFilter"
            :showClearAll="isClearAllEnabled()"
        />
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import CommonFilterTool from "../../../Pages/Chatbot/pages/archive/CommonFilterTool.vue";
import log2 from "../../../../utils/log2";
import _ from "lodash";
import moment from "moment";

const log = log2("ContactListFilterToolBar");
export default {
    name: "ContactListFilterToolBar",
    components: { CommonFilterTool },
    data() {
        return {
            filterMetas: [
                {
                    name: "selectedPaymentMethod",
                    label: "Ödeme Yöntemi",
                    materialIcon: "payments",
                    controlType: "multi-select",
                    controlProps: {},
                    defaultValue: ["all"],
                    options: () => [
                        {
                            value: "all",
                            label: "All",
                        },
                        {
                            value: "credit-card",
                            label: "credit-card",
                        },
                        {
                            value: "eft",
                            label: "eft",
                        },
                        {
                            value: "btc",
                            label: "btc",
                        },
                    ],
                },
                {
                    name: "selectedAgentCount",
                    label: "temsilci sayısı",
                    materialIcon: "people",
                    controlType: "range-count",
                    controlProps: {},
                    defaultValue: [1, 10],
                },
                {
                    name: "selectedFreeDays",
                    label: "Deneme gün Sayısı",
                    materialIcon: "hub",
                    controlType: "range-count",
                    controlProps: {},
                    defaultValue: [1, 10],
                },
                {
                    name: "selectedBalanceAmount",
                    label: "sitenin bakiyesi",
                    materialIcon: "account_balance_wallet",
                    controlType: "range-count",
                    controlProps: {},
                    defaultValue: [0, 1000],
                },
                {
                    name: "selectedInvoiceAmount",
                    label: "fatura tutarı",
                    materialIcon: "receipt",
                    controlType: "range-count",
                    controlProps: {},
                    defaultValue: [0, 1000],
                },
                {
                    name: "selectedDiscountRate",
                    label: "indirim oranı",
                    materialIcon: "discount",
                    controlType: "range-count",
                    controlProps: {},
                    defaultValue: [0, 10],
                },
            ],
            breakdownFilter: [],
            newFilterValue: "",
        };
    },
    computed: {
        ...mapState({
            users: (state) => state.user.users.data,
            departments: (state) => state.subject.subjects.data,
            channels: (state) => state.channel.channels,
            contactListFilters: (state) => state.chat.contactListFilters,
        }),
    },
    mounted() {},
    methods: {
        isClearAllEnabled() {
            return this.breakdownFilter.length > 1;
        },
        getDepartmentName(department) {
            return (
                _.get(department, `languageContent.${this.$i18n.locale}.name`) ||
                _.get(department, `languageContent.${Object.keys(department.languageContent)[0]}.name`)
            );
        },

        addFilter(name, value) {
            const meta = this.filterMetas.find((x) => x.name === name);
            const filter = this.breakdownFilter.find((x) => x.name === name);
            log.info("addFilter", { name, value, meta, filter });
            this.newFilterValue = value;
            if (filter) {
                this.breakdownFilter = this.breakdownFilter.map((x) => {
                    if (x.name === name) {
                        x.filterValue = value || meta.defaultValue;
                    }
                    return x;
                });
            } else {
                this.breakdownFilter.push({
                    ...meta,
                    filterValue: value || meta.defaultValue,
                });
            }
        },
        removeFilter(name) {
            log.info("removeFilter", name);
            this.breakdownFilter = this.breakdownFilter.filter((x) => x.name !== name);
        },
        filterLabelFormatter(name, value) {
            const filter = this.filterMetas.find((x) => x.name === name);
            log.info("filterLabelFormatter", { name, value, filter, isType: filter.controlType === "multi-select" });
            if (filter.controlType === "select") {
                const option = filter.options().find((x) => x.id === value);
                if (option) {
                    return `${filter.label}: ${option.label}`;
                }
            } else if (filter.controlType === "multi-select") {
                const option = filter.options().find((x) => x.id === value);
                if (option) {
                    console.log("multi-select...", `${filter.label}: ${option.label}`);
                    return `${filter.label}: ${option.label}`;
                }
            } else if (filter.controlType === "range-count") {
                return `${filter.label}: ${value[0]} - ${value[1]}`;
            }

            if (value) {
                return `${value}`;
            }
            return filter.label;
        },
    },
    watch: {
        breakdownFilter: {
            handler: _.debounce(function () {
                this.$emit("updateFilters", this.breakdownFilter);
            }, 500),
            deep: true,
        },
        contactListFilters: {
            handler: function () {
                this.breakdownFilter = this.breakdownFilter.map((meta) => {
                    return {
                        ...meta,
                        filterValue:
                            {
                                selectedInteractions:
                                    meta.name === "selectedInteractions"
                                        ? this.contactListFilters.selectedInteractions
                                        : meta.filterValue,
                                selectedDepartmentIds:
                                    meta.name === "selectedDepartmentIds"
                                        ? this.contactListFilters.selectedDepartmentIds
                                        : meta.filterValue,
                                selectedChannelIds:
                                    meta.name === "selectedChannelIds"
                                        ? this.contactListFilters.selectedChannelIds
                                        : meta.filterValue,
                                startDate:
                                    meta.name === "dateFilter" ? this.contactListFilters.startDate : meta.filterValue,
                                endDate:
                                    meta.name === "dateFilter" ? this.contactListFilters.endDate : meta.filterValue,
                                timeSelect:
                                    meta.name === "dateFilter" ? this.contactListFilters.timeSelect : meta.filterValue,
                                lastChatStatus:
                                    meta.name === "lastChatStatus"
                                        ? this.contactListFilters.lastChatStatus
                                        : meta.filterValue,
                            }[meta.name] || meta.filterValue,
                    };
                });
            },
            deep: true,
        },
    },
};
</script>

<style lang="scss">
.contact-filters-toolbar {
    display: flex;
    width: 100%;

    .contact-filters-toolbar {
        margin-bottom: 10px;
    }

    .common-filter-tool {
        border-bottom: none;
        overflow: hidden;
        padding: 0px;

        .filters {
            //flex-wrap: unset !important;
            overflow-x: auto;
            overflow-y: hidden;
            scrollbar-width: none;
        }

        .add-button {
            margin: unset !important;
            border-radius: 20px;
            border: 1px dashed var(--color-border-default);
            font-size: 12px;
            font-weight: 600;
            line-height: 24px;
            padding: 1px 5px !important;
            min-width: fit-content;

            .material-icons {
                font-size: 15px;
                margin-right: 3px;
            }
        }

        .clear-preview {
            font-size: 12px;
            font-weight: 600;
            line-height: 24px;

            .material-icons {
                font-size: 15px;
                margin-right: 3px;
            }
        }

        .filter-wrapper-preview {
            border-radius: 20px;
            padding: 1px 5px !important;
            background: white;
            color: black;
            border: 1px solid var(--color-border-default);

            .filter-value-text {
                font-size: 12px;
                font-weight: 600;
                color: #22272d;
                line-height: 24px;
            }

            .material-icons {
                margin-right: 3px;
            }
        }
    }
}

.active-filters {
    display: flex;
    gap: 5px;
    overflow-x: auto;
    padding: 10px 0;
    overflow-y: hidden;

    &::-webkit-scrollbar {
        display: none;
    }

    .clear-active-filter {
        width: max-content;
        height: 30px;
        background-color: #000;
        color: #fff;
        border-radius: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 7px;
        cursor: pointer;
    }

    .active-filter-group {
        display: flex;
        gap: 5px;
        height: 40px;
    }

    .active-filter {
        display: flex;
        align-items: center;
        background-color: #fff;
        border-radius: 16px;
        padding: 10px 0 10px 10px;
        position: relative;
        width: max-content;
        height: 30px;
        border: 1px solid #d2d2d2;

        .remove-filter {
            cursor: pointer;
            background-color: #fff;
            border-radius: 50%;
            padding: 0 5px;
            margin-left: 5px;
            color: #d2d2d2;
            font-size: 15px;
            font-weight: 900;
        }
    }
}
</style>
